export const videos = {
   index_slide_01: require('../images/index_slide_01.mp4'),
   index_slide_02: require('../images/index_slide_02.mp4'),
   index_slide_03: require('../images/index_slide_03.mp4'),
   index_slide_04: require('../images/index_slide_04.mp4'),
   about: require('../images/about.mp4'),
 };